import { useId } from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';

const WiredIcon = (props: SvgIconProps) => {
  const clipId = useId();
  return (
    <SvgIcon viewBox="0 0 150 150" {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M97.9375 50H131.25V43.75H150V6.25H131.25V0H97.9375C92.1875 0 87.5 4.6875 87.5 10.4375V18.75H37.5C20.25 18.75 6.25 32.75 6.25 50C6.25 67.25 20.25 81.25 37.5 81.25H112.5C122.812 81.25 131.25 89.6875 131.25 100C131.25 110.312 122.812 118.75 112.5 118.75H62.5V110.438C62.5 104.688 57.8125 100 52.0625 100H18.75V106.25H0V143.75H18.75V150H52.0625C57.8125 150 62.5 145.312 62.5 139.562V131.25H112.5C129.75 131.25 143.75 117.25 143.75 100C143.75 82.75 129.75 68.75 112.5 68.75H37.5C27.1875 68.75 18.75 60.3125 18.75 50C18.75 39.6875 27.1875 31.25 37.5 31.25H87.5V39.5625C87.5 45.3125 92.1875 50 97.9375 50ZM6.25 137.5V112.5H18.75V137.5H6.25ZM143.75 12.5V37.5H131.25V12.5H143.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="150" height="150" fill="currentColor" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default WiredIcon;
